<template>
  <div class="py-4 container-fluid">
    <div class=" row">
      <div class="col-12">
        <div class="card">
    <div class="card-header pb-0">
      <h6>Lista de tareas</h6>
    </div>
    <div class="card-body px-0 pt-0 pb-2">
      <!-- Barra de acciones: botones Recibir / Entregar según selección -->
      <div class="d-flex align-items-center justify-content-end px-3 pb-2" style="gap: 10px;">
        <div class="d-flex align-items-center" style="gap: 10px;">
          <button
            v-if="selectedRows.length > 0 && selectedBaseAction === 'receive'"
            type="button"
            class="btn btn-info btn-sm"
            @click="markSelectedReceived"
          >
            Recibir
          </button>
          <button
            v-if="selectedRows.length > 0 && selectedBaseAction === 'deliver'"
            type="button"
            class="btn btn-primary btn-sm"
            @click="markSelectedDelivered"
          >
            Entregar
          </button>
        </div>
      </div>
      <div class="table-responsive p-0">

        <table class="table align-items-center mb-0">
          <thead>
            <tr>
              
              <th
                class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
              >Opciones</th>
              <th
                class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
              >Producción asignada</th>
              <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Detalle tarea</th>
              <th
                class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
              >Unidades totales</th>
              <th
                class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
              >Fecha recibido</th>
              <th
                class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
              >Fecha entregado</th>
              <th
                class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
              >Fecha validado</th>
              <th
                class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
              >observación</th>
            </tr>
          </thead>
          <tbody>
            <tr  v-for="value in data" :key="value.id">

              <td class="align-middle text-center">
                <div class="d-flex justify-content-center align-items-center gap-2" style="min-height: 36px;">
                  <!-- Pendiente: checkbox para Recibir o Entregar -->
                  <template v-if="!isFullyDelivered(value)">
                    <div class="custom-checkbox-wrapper">
                      <input
                        type="checkbox"
                        class="custom-checkbox"
                        :id="'checkbox-task-' + value.id"
                        :value="value.id"
                        v-model="selectedTaskIds"
                        :disabled="isTaskCheckboxDisabled(value)"
                      />
                      <label :for="'checkbox-task-' + value.id" class="custom-checkbox-label">
                        <i class="fa fa-check"></i>
                      </label>
                    </div>
                  </template>
                  <!-- Solo cuando está todo confirmado: chulo verde -->
                  <span v-else class="operator-check-confirmed" title="Trabajo entregado">
                    <i class="fa fa-check"></i>
                  </span>
                </div>
              </td>

              <td class="align-middle text-center">
                <span class="badge badge-sm" :class="productionTypeBadgeClass(value)">
                  {{ productionTypeLabel(value) }}
                </span>
              </td>

              <td class="align-middle">
                <div class="text-secondary text-xs font-weight-bold">
                  Tipo: {{ productionTypeLabel(value) }}
                </div>
                <div
                  class="text-secondary text-xs font-weight-bold"
                  v-if="value.production && value.production.consecutivo"
                >
                  Producción: {{ value.production.consecutivo }}
                </div>
                <div
                  class="text-secondary text-xs font-weight-bold"
                  v-if="value.production_oven && value.production_oven.oven"
                >
                  Horno: {{ value.production_oven.oven.name }}
                </div>
                <div class="text-secondary text-xs font-weight-bold" v-if="value?.model?.model?.name">
                  Referencia: {{  value?.model?.model?.name  }}
                </div>
              </td>
              <td class="align-middle text-center">
                <!-- Unidades totales:
                     - Producción: modelo de la producción + cantidad de extrusión
                     - Cargue: lista de productos cargados en el horno (por oven_id)
                     - Descargue: lista de productos descargados del horno
                     - Otros: muestra solo la cantidad asignada -->
                <div v-if="productionTypeLabel(value) === 'Producción'">
                  <span class="text-secondary text-xs font-weight-bold">
                    {{ value?.production?.model?.name || 'Sin referencia' }}:
                    {{ formatNumber(value?.production?.extrusion?.extrusion_quantity) }}
                  </span>
                </div>
                <div v-else-if="productionTypeLabel(value) === 'Cargue'">
                  <div
                    v-if="ovenLoadingSummary[value.production_oven_id] && ovenLoadingSummary[value.production_oven_id].length"
                  >
                    <div
                      v-for="item in ovenLoadingSummary[value.production_oven_id]"
                      :key="'c-' + value.production_oven_id + '-' + item.model_id"
                      class="text-secondary text-xs font-weight-bold"
                    >
                      {{ item.model_name }}: {{ formatNumber(item.total_quantity) }}
                    </div>
                  </div>
                  <span
                    v-else
                    class="text-secondary text-xs font-weight-bold"
                  >
                    {{ formatNumber(value?.received_quantity) }}
                  </span>
                </div>
                <div v-else-if="productionTypeLabel(value) === 'Descargue'">
                  <div
                    v-if="ovenUnloadingSummary[value.production_oven_id] && ovenUnloadingSummary[value.production_oven_id].length"
                  >
                    <div
                      v-for="(item, idx) in ovenUnloadingSummary[value.production_oven_id]"
                      :key="'d-' + value.production_oven_id + '-' + idx"
                      class="text-secondary text-xs font-weight-bold"
                    >
                      {{ item.name }}: {{ formatNumber(item.total_quantity) }}
                    </div>
                  </div>
                  <span
                    v-else
                    class="text-secondary text-xs font-weight-bold"
                  >
                    {{ formatNumber(value?.received_quantity) }}
                  </span>
                </div>
                <span
                  v-else
                  class="text-secondary text-xs font-weight-bold"
                >
                  {{ formatNumber(value?.received_quantity) }}
                </span>
              </td>
              <td class="align-middle text-center">
                <span class="text-secondary text-xs font-weight-bold">
                  {{ formatDateTimeLocal(value.received_date) }}
                </span>
              </td>
              <td class="align-middle text-center">
                <span class="text-secondary text-xs font-weight-bold">
                  {{ formatDateTimeLocal(value.delivered_date) }}
                </span>
              </td>
              <td class="align-middle text-center">
                <span class="text-secondary text-xs font-weight-bold">
                  {{ formatDateTimeLocal(value.validated_date) }}
                </span>
              </td>
              <td class="align-middle text-center">
                <span class="text-secondary text-xs font-weight-bold">
                {{ value.observation }}
                </span>
              </td>

             
            </tr>
           
          </tbody>
        </table>

        <div class="pagination p-3">
          <!-- Recorremos los links para generar los botones -->
          <a 
            v-for="link in links" 
            :key="link.label" 
            class="page-item cursor-pointer" 
            @click="fetchData(link.url)" 
            :disabled="!link.url || link.active" 
            :class="{ 'active': link.label === currentPage.toString() }"
          >
            {{ link.label }}
          </a>
        </div>

      </div>

    
    </div>
  </div>
      </div>
    </div>
  </div>
</template>


<script>
import { mapGetters } from 'vuex';
import Swal from 'sweetalert2';

export default {
  name: 'OperatorProductionUserTables',
  data() {
    return {
      selectedTaskIds: [],
      /** Mapas por horno: listado de productos cargados/descargados con su cantidad */
      ovenLoadingSummary: {},   // { [production_oven_id]: [{ model_id, model_name, total_quantity }, ...] }
      ovenUnloadingSummary: {}, // { [production_oven_id]: [{ name, total_quantity }, ...] }
    };
  },
  computed: {
    ...mapGetters('productionUsers', ['allData','currentPage', 'lastPage', 'pagination', 'links']),
    currentPage() {
        return this.$store.state.productionUsers.currentPage;
    },
    lastPage() {
        return this.$store.state.productionUsers.lastPage;
    },
    data() {
        return this.allData;
    },
    links() {
      return this.$store.getters['productionUsers/links'];
    },
    /** Filas seleccionadas (por id) */
    selectedRows() {
      const set = new Set((this.selectedTaskIds || []).map(Number));
      return (this.data || []).filter((r) => set.has(Number(r.id)));
    },
    /** Acción del primer seleccionado: 'receive' | 'deliver' | null (igual que asignar usuarios) */
    selectedBaseAction() {
      const first = this.selectedRows[0];
      return first ? this.getTaskNextAction(first) : null;
    },
    /** Totales de cantidad recibida por tipo de módulo (para el operario actual) */
    totalReceived() {
      const rows = this.data || [];
      let productionExtraction = 0;
      let cargue = 0;
      let descargue = 0;
      for (const r of rows) {
        const qty = Number(r.received_quantity) || 0;
        if (!qty) continue;
        const mod = Number(r.modulo);
        if (mod === 3) {
          cargue += qty;
        } else if (mod === 4) {
          descargue += qty;
        } else if (mod === 1 || mod === 2) {
          productionExtraction += qty;
        }
      }
      const total = productionExtraction + cargue + descargue;
      return { productionExtraction, cargue, descargue, total };
    },
  },
  methods: {
    /** Fecha actual en hora local (YYYY-MM-DD) para no usar UTC */
    nowLocalDate() {
      const now = new Date();
      const pad = (n) => String(n).padStart(2, '0');
      return `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())}`;
    },
    /** Fecha y hora actual en hora local (YYYY-MM-DD HH:mm:ss) para el API */
    nowLocalDateTime() {
      const now = new Date();
      const pad = (n) => String(n).padStart(2, '0');
      return `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())} ${pad(now.getHours())}:${pad(now.getMinutes())}:${pad(now.getSeconds())}`;
    },
    /** Siguiente acción para esta tarea: receive, deliver, o null si ya entregado */
    getTaskNextAction(value) {
      if (this.hasNoReceivedDate(value)) return 'receive';
      if (this.hasNoDeliveredDate(value) && !this.isFullyDelivered(value)) return 'deliver';
      return null;
    },
    /** Deshabilita el check si la acción de la fila no coincide con la de la selección actual */
    isTaskCheckboxDisabled(value) {
      const action = this.getTaskNextAction(value);
      if (action == null) return true;
      const selectedSet = new Set((this.selectedTaskIds || []).map(Number));
      if (selectedSet.has(Number(value.id))) return false;
      if (!this.selectedBaseAction) return false;
      return action !== this.selectedBaseAction;
    },
    /** Tipo de relación: Producción, Horno, Cargue o Descargue según campos de la BD */
    productionTypeLabel(value) {
      if (!value) return '—';
      if (value.production_oven_id) {
        const mod = Number(value.modulo);
        if (mod === 3) return 'Cargue';
        if (mod === 4) return 'Descargue';
        return 'Horno';
      }
      if (value.production_id) return 'Producción';
      return 'Sin producción';
    },
    productionTypeBadgeClass(value) {
      const label = this.productionTypeLabel(value);
      if (label === 'Producción') return 'bg-gradient-info';
      if (label === 'Cargue') return 'bg-gradient-warning';
      if (label === 'Descargue') return 'bg-gradient-success';
      if (label === 'Horno') return 'bg-gradient-dark';
      return 'bg-gradient-secondary';
    },
    async fetchData(pageUrl = null) {
      await this.$store.dispatch('productionUsers/fetchData', pageUrl);

      // Después de cargar las tareas, precargar los resúmenes de cargue/descargue por horno
      const rows = this.data || [];
      const ovenIds = Array.from(
        new Set(
          rows
            .filter((r) => r.production_oven_id)
            .map((r) => Number(r.production_oven_id))
        )
      );
      for (const ovenId of ovenIds) {
        await this.ensureOvenSummaries(ovenId);
      }
    },
    isValidDate(date) {
      if (!date) return false;
      const parsedDate = new Date(date);
      return !isNaN(parsedDate.getTime());
    },
    /** Formatea número para mostrar totales (separadores miles, sin decimales) */
    formatNumber(value) {
      return Number(value || 0).toLocaleString('es-ES', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      });
    },
    /** Formatea fecha/hora para mostrar en hora local (evita desfase por UTC) */
    formatDateTimeLocal(dateVal) {
      if (!dateVal || !this.isValidDate(dateVal)) return 'Sin asignar';
      const d = new Date(dateVal);
      return d.toLocaleString('es-ES', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        hour12: true,
      });
    },
    /** True si la tarea aún no tiene fecha de recibido (permite recibir) */
    hasNoReceivedDate(value) {
      const d = value?.received_date;
      if (d == null || d === '') return true;
      if (typeof d === 'string' && d.trim() === '') return true;
      return !this.isValidDate(d);
    },
    /** True si ya recibió pero aún no tiene fecha de entrega (permite entregar) */
    hasNoDeliveredDate(value) {
      const d = value?.delivered_date;
      if (d == null || d === '') return true;
      if (typeof d === 'string' && d.trim() === '') return true;
      return !this.isValidDate(d);
    },
    /** True solo cuando la tarea está totalmente entregada: tiene fecha inicio Y fecha de entrega (no solo cantidades) */
    isFullyDelivered(value) {
      if (this.hasNoReceivedDate(value)) return false;
      if (this.hasNoDeliveredDate(value)) return false;
      return true;
    },
    /** Marcar como recibidos los seleccionados (operario solo registra fecha, no cantidades) */
    async markSelectedReceived() {
      const eligible = this.selectedRows.filter((r) => this.getTaskNextAction(r) === 'receive');
      if (eligible.length === 0) {
        await Swal.fire({ icon: 'info', title: 'Sin registros', text: 'Selecciona al menos una tarea pendiente de recibir.' });
        return;
      }
      try {
        const result = await Swal.fire({
          title: 'Marcar como recibido',
          text: `Se registrará la fecha de recibido para ${eligible.length} tarea(s).`,
          icon: 'question',
          showCancelButton: true,
          confirmButtonText: 'Sí, continuar',
          cancelButtonText: 'Cancelar',
        });
        if (!result.isConfirmed) return;
        const fecha = this.nowLocalDateTime();
        for (const row of eligible) {
          const payload = { ...row, received_date: fecha };
          await this.$store.dispatch("productionUsers/save", payload);
        }
        this.selectedTaskIds = [];
        await Swal.fire({ icon: 'success', title: 'Tarea(s) recibida(s)', text: `Registradas: ${eligible.length}` });
        this.fetchData();
      } catch (err) {
        console.error(err);
        await Swal.fire({ icon: 'error', title: 'Error', text: err.message || 'Error al guardar.' });
      }
    },
    /** Marcar como entregados los seleccionados (operario solo registra fecha, no cantidades) */
    async markSelectedDelivered() {
      const eligible = this.selectedRows.filter((r) => this.getTaskNextAction(r) === 'deliver');
      if (eligible.length === 0) {
        await Swal.fire({ icon: 'info', title: 'Sin registros', text: 'Selecciona al menos una tarea pendiente de entregar.' });
        return;
      }
      try {
        const result = await Swal.fire({
          title: 'Marcar como entregado',
          text: `Se registrará la fecha de entrega para ${eligible.length} tarea(s).`,
          icon: 'question',
          showCancelButton: true,
          confirmButtonText: 'Sí, continuar',
          cancelButtonText: 'Cancelar',
        });
        if (!result.isConfirmed) return;
        const fecha = this.nowLocalDateTime();
        for (const row of eligible) {
          const payload = {
            ...row,
            delivered_date: fecha,
          };
          await this.$store.dispatch("productionUsers/save", payload);
        }
        this.selectedTaskIds = [];
        await Swal.fire({ icon: 'success', title: 'Tarea(s) entregada(s)', text: `Registradas: ${eligible.length}` });
        this.fetchData();
      } catch (err) {
        console.error(err);
        await Swal.fire({ icon: 'error', title: 'Error', text: err.message || 'Error al guardar.' });
      }
    },
    // Estos métodos ya no se usan en el flujo actual (solo fechas), pero se dejan simples por si se llaman desde otro lado.
    async checkReceived(value) {
      try {
        value.received_date = this.nowLocalDateTime();
        const response = await this.$store.dispatch("productionUsers/save", value);
        if (response && response.status >= 200 && response.status < 300) {
          await Swal.fire('Tarea recibida!', 'Fecha registrada correctamente.', 'success');
          this.fetchData();
        } else {
          throw new Error(response.data.message || 'Error al guardar el registro');
        }
      } catch (error) {
        console.error("Error al guardar el registro:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message || 'Error al guardar el registro',
        });
      }
    },
    async checkDelivered(value) {
      try {
        const payload = { ...value, delivered_date: this.nowLocalDateTime() };
        const response = await this.$store.dispatch("productionUsers/save", payload);
        if (response && response.status >= 200 && response.status < 300) {
          await Swal.fire('Tarea Entregada!', 'Fecha registrada correctamente.', 'success');
          this.fetchData();
        } else {
          throw new Error(response.data.message || 'Error al guardar el registro');
        }
      } catch (error) {
        console.error("Error al guardar el registro:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message || 'Error al guardar el registro',
        });
      }
    },
    /** Cargar (si hace falta) los resúmenes de cargue y descargue para un horno concreto */
    async ensureOvenSummaries(ovenId) {
      if (!ovenId) return;
      const id = Number(ovenId);
      const needsCargue = !this.ovenLoadingSummary[id];
      const needsDescargue = !this.ovenUnloadingSummary[id];
      if (!needsCargue && !needsDescargue) return;

      try {
        const [cargue, descargue] = await Promise.all([
          needsCargue
            ? this.$store.dispatch('productionLoading/getData', id)
            : Promise.resolve(this.ovenLoadingSummary[id]),
          needsDescargue
            ? this.$store.dispatch('productionUnloading/getData', id)
            : Promise.resolve(this.ovenUnloadingSummary[id]),
        ]);

        if (needsCargue && Array.isArray(cargue)) {
          // Cargue: usar las mismas filas que en la tabla "CARGUE HORNO"
          // (ProductionLoadingController@show: /production-loading/{production_oven_id})
          const mappedLoadings = cargue.map((l) => ({
            model_id: l?.id,
            model_name:
              (l &&
                l.driying &&
                l.driying.production &&
                l.driying.production.model &&
                l.driying.production.model.name) ||
              'Sin referencia',
            total_quantity: Number(l.total_quantity ?? l.quantity ?? 0) || 0,
          }));
          this.ovenLoadingSummary = {
            ...this.ovenLoadingSummary,
            [id]: mappedLoadings,
          };
        }

        if (needsDescargue && Array.isArray(descargue)) {
          // descargue: lista de registros con inventory/name y total_quantity
          const mapped = descargue.map((u) => ({
            name:
              (u && u.inventory && u.inventory.name) ||
              (u &&
                u.modulo &&
                u.modulo.driying &&
                u.modulo.driying.production &&
                u.modulo.driying.production.model &&
                u.modulo.driying.production.model.name) ||
              'Sin referencia',
            total_quantity: Number(u.total_quantity) || 0,
          }));
          this.ovenUnloadingSummary = {
            ...this.ovenUnloadingSummary,
            [id]: mapped,
          };
        }
      } catch (error) {
        // No rompemos la vista si falla; simplemente dejamos el valor original
        console.error('Error cargando resúmenes de horno', ovenId, error);
      }
    },
  },
  mounted() {
    this.fetchData(); // Llama a fetchUsers cuando el componente se monta
  },
};
</script>

<style scoped>
.pagination {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}
.page-item {
  margin: 0 5px;
}
.active {
  font-weight: bold; /* Estilo para la página activa */
}

/* Tarjetas de totales de recibido */
.total-pill {
  font-size: 0.75rem;
  color: #5f6368;
  background-color: #f8f9fa;
  border-radius: 999px;
  padding: 4px 10px;
  border: 1px solid #e0e0e0;
}
.total-pill strong {
  color: #111827;
}
.total-pill-strong {
  background-color: #e8f5e9;
  border-color: #c8e6c9;
}

/* Checkbox tipo asignar usuarios (operator) */
.custom-checkbox-wrapper {
  position: relative;
  display: inline-block;
}
.custom-checkbox {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}
.custom-checkbox-label {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  border: 1.5px solid #6c757d;
  background-color: white;
  cursor: pointer;
  transition: all 0.2s ease;
  margin: 0;
}
.custom-checkbox-label i {
  font-size: 10px;
  color: transparent;
  transition: color 0.2s ease;
}
.custom-checkbox:checked + .custom-checkbox-label {
  background-color: #28a745;
  border-color: #28a745;
}
.custom-checkbox:checked + .custom-checkbox-label i {
  color: white;
}
.custom-checkbox:hover + .custom-checkbox-label {
  border-color: #28a745;
}
.custom-checkbox:disabled + .custom-checkbox-label {
  opacity: 0.5;
  cursor: not-allowed;
}

/* Check confirmado (todos los checks listos): check verde destacado, centrado */
.operator-check-confirmed {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
}
.operator-check-confirmed i {
  color: #28a745;
  font-size: 16px;
  font-weight: bold;
  line-height: 1;
}
</style>
